import { render, staticRenderFns } from "./ReceiptReport.vue?vue&type=template&id=a84fdf1e&scoped=true"
import script from "./ReceiptReport.vue?vue&type=script&lang=js"
export * from "./ReceiptReport.vue?vue&type=script&lang=js"
import style0 from "./ReceiptReport.vue?vue&type=style&index=0&id=a84fdf1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84fdf1e",
  null
  
)

export default component.exports